const VARIANT_SIZES = Object.freeze({ avatar: 64, preview: 160 });

export function getCoachImageVariantUrl(settings = {}, variant = 'avatar') {
  const original = settings.image_url || null;
  if (!original) return null;

  const size = VARIANT_SIZES[variant];
  const persisted = variant === 'preview' ? settings.image_preview_url : settings.image_thumbnail_url;
  if (persisted && (!persisted.includes('/coach-image-thumb/') || persisted.includes(`/coach-image-thumb/${size}/`))) {
    return persisted;
  }
  if (size && original.includes('/coach-image/')) {
    return original.replace('/coach-image/', `/coach-image-thumb/${size}/`);
  }
  return persisted || original;
}
